import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Walidator sprawdzający, czy pole nie zawiera samych białych znaków (spacji, tabulatorów itp.)
 * Pole musi zawierać przynajmniej jeden widoczny znak.
 */
export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null; // puste pole obsługuje Validators.required
    const trimmed = typeof control.value === 'string' ? control.value.trim() : control.value;
    return trimmed.length === 0 ? { whitespace: true } : null;
  };
}
